import React from 'react';
import { Tabs, Tab } from '@mui/material';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

const CertificationTabs = ({ cards, activeTab, handleVerticalClick, selectedYear }) => {
  const navigate = useNavigate();
  const navigateToMap = () => {
    navigate('/certifications/map?vertical=total', { state: { fromPage: true, userSelectedYear: selectedYear } });
  };
  return (
    <Tabs
      indicatorColor="primary"
      textColor="primary"
      variant="scrollable"
      scrollButtons
      id="target-horizontal-tabs"
    >
      {cards.map((vertical, index) => (
        <Tab
          className={`tab-content ${activeTab === index ? 'active' : ''}`}
          key={vertical?.title}
          onClick={() => {
            if (vertical.title !== 'Total active') {
              handleVerticalClick(index, vertical.title);
            } else {
              navigateToMap();
            }
          }}
          label={
            <div className="tab-content-inner">
              <img
                className="target-icon"
                src={vertical.icon}
                alt="Target Icon"
                height="24"
                width="24"
              />
              <div className="tab-details">
                <div className="tab-title">{vertical.title}</div>
                <div className="tab-value">{vertical.value}</div>
              </div>
            </div>
          }
          value={vertical.title}
        />
      ))}
    </Tabs>
  );
};

CertificationTabs.propTypes = {
  cards: PropTypes.array.isRequired,
  activeTab: PropTypes.number.isRequired,
  handleVerticalClick: PropTypes.func.isRequired,
  selectedYear: PropTypes.number.isRequired,
};

export default CertificationTabs;
